module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonerebranding-04.e3c424d9.jpg";